export default "__VITE_ASSET__C475DCGs__"